export default __webpack_public_path__ + "static/media/run_walk_jump_walk.0f3ad37c.gif";